export default {
  botTitle: ['Nom du bot', 'Bot name'],
  botImage: ['Image par défaut', 'Default image'],
  botImageSub: [
    "Elle sera envoyée lorsqu'un événement n'a pas d'image",
    'It will be sent when an event has no image',
  ],
};
